import React, { useCallback, useEffect, useMemo, useState } from "react";

import MasterFilterForm from "./MasterFilterForm";
import MasterPincodeTable from "./MasterPincodeTable";
import MasterPincodeAdd from "./MasterPincodeAdd";
import MasterPincodeEdit from "./MasterPincodeEdit";

import useApiNew from "../../../utils/useApiNew";
import axios from "axios";

import Breadcrumbs from "../../../components/ui/Breadcrumbs";
import DeleteAlert from "../../../components/ui/DeleteAlert";

import Notification, {
  errorNotify,
  successNotify,
} from "../../../Services/Notification";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const pincodeApiURL = `${process.env.REACT_APP_API_URL}api/pincode`;
const exportPincodeApiURL = `${process.env.REACT_APP_API_URL}api/export-pincode`;

const MasterPincode = () => {
  const [renderKey, setRenderKey] = React.useState(0);
  const [isAdd, setIsAdd] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = React.useState();
  const [filterData, setFilterData] = useState([]);
  const [finalFilterData, setFinalFilterData] = useState(null);
  const [selectedItem, setSelectedItem] = useState();
  const [isFilter, setIsFilter] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();

  const name = "pin code";

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  // GET FILTER DATA
  const getFilterPincode = (data) => {
    setFilterData(data);
  };

  const { data: pincodeData, loading } = useApiNew(
    pincodeApiURL,
    "GET",
    { headers },
    renderKey,
  );

  // FILTER PINCODE
  useEffect(() => {
    const handleFilterData = () => {
      if (
        (filterData.pincode === undefined &&
          filterData.city === undefined &&
          filterData.state === undefined) ||
        (filterData.pincode === "" &&
          filterData.city === "" &&
          filterData.state === "")
      ) {
        setFinalFilterData(pincodeData);
      } else {
        const singleData = pincodeData?.filter((data) => {
          const pincodeMatch = data?.pincode === parseInt(filterData.pincode);

          const cityMatch =
            data?.city.toLowerCase() === filterData.city.toLowerCase();
          const state =
            data?.state.toLowerCase() === filterData.state.toLowerCase();

          return pincodeMatch || cityMatch || state;
        });

        setFinalFilterData(singleData);
      }
    };

    handleFilterData();
  }, [filterData, pincodeData]);

  const data = finalFilterData;

  // GET ONE

  const handleGetOnePincode = async (id) => {
    const ugetOneAPI = `${pincodeApiURL}/${id}`;

    try {
      const res = await axios.get(ugetOneAPI, data, { headers });
      const resData = res.data.data;
      if (!resData.error) return resData;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  // ADD
  const handleAddPincode = async (data) => {
    setIsButtonClicked(true);
    try {
      const res = await axios.post(pincodeApiURL, data, { headers });
      const resData = res.data;

      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return null;
    }
  };

  // EDIT
  const handleEditPincode = async (id, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${pincodeApiURL}/${id}`;

    try {
      const res = await axios.put(updateAPI, data, { headers });
      const resData = res.data;
      console.log(resData);

      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeletePincode = async (segmentId) => {
    const deleteAPI = `${pincodeApiURL}/${segmentId}`;
    try {
      const res = await axios.delete(deleteAPI, { headers });
      const resData = res.data;
      console.log(resData);
      triggerRerender();
      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      } else {
        errorNotify(resData?.message);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  // download

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportPincodeApiURL;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      errorNotify("Something went wrong.");
      setIsDownloadClicked(false);
    }
  };

  const downloadPincode = () => {
    setIsDownloadClicked(true);
    const filename = `Pincode-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };

  const breadcrumbs = ["Home", "Master", "Pincode"];

  const buttonConfig = {
    value: "pincode",
    name: "Pincode",
    getOneHandler: handleGetOnePincode,
    getfilterOption: getFilterPincode,
    addHandler: handleAddPincode,
    editHandler: handleEditPincode,
    deleteHandler: handleDeletePincode,
    downloadHandler: downloadPincode,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };

  // if (!data) return null;

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterFilterForm
        buttonConfig={buttonConfig}
        isFilter={isFilter}
        setIsFilter={setIsFilter}
      />
      <MasterPincodeTable
        tableData={data}
        buttonConfig={buttonConfig}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setSelectedItemId={setSelectedItemId}
        setSelectedItem={setSelectedItem}
        renderKey={renderKey}
        loading={loading}
        actionPermissions={actionPermissions("masters", "Pin Code")}
        isFilter={isFilter}
        setIsFilter={setIsFilter}
        isDownloadClicked={isDownloadClicked}
      />
      {isAdd && (
        <MasterPincodeAdd
          buttonConfig={buttonConfig}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isEdit && (
        <MasterPincodeEdit
          buttonConfig={buttonConfig}
          selectedItem={selectedItem}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterPincode;
